import React from "react";
import { Phone } from "lucide-react";
import { BUSINESS } from "../lib/assets";

/**
 * Mobile-only floating "Call to Order" button. Opens the dialer via tel: link.
 */
export default function CallToOrder() {
  return (
    <a
      href={`tel:${BUSINESS.phoneRaw}`}
      data-testid="mobile-call-btn"
      aria-label={`Call ${BUSINESS.phone}`}
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 border-2 border-bone bg-ink px-4 py-3 font-mono text-[11px] uppercase tracking-[0.2em] text-bone shadow-hard-invert transition-transform duration-200 hover:scale-105 md:hidden"
    >
      <Phone size={14} />
      <span>Call to Order</span>
    </a>
  );
}
